module.exports = __webpack_public_path__ + "static/media/a1.9e044128.jpg";